
<template  >
  <div>
    <template v-for="post in posts">
      <template v-if="posts">
        <InvestPostItem :key="post.id" :item="post" />
      </template>
    </template>
  </div>
</template>

<script>
import InvestPostItem from '@/components/newRedesign/InvestPostItem.vue';

export default {
  props: {
    posts: Array
  },
  data: () => {
    return {
    }
  },
  components: {
    InvestPostItem,
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss"></style>
